import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../core/auth.service';
import { BaseService } from '../shared/base.service';
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';

@Component({
    selector: 'self-report-setting-component',
    templateUrl: './self-report-setting.component.html',
    providers: [BaseService]
})

export class SelfReportSettingComponent extends BaseComponent implements OnInit {
    helpDomainProfile: any;
    readonly tableColumns = [
        // ['customer_id', 'Customer ID', 'col-xs-2' , 'customer_id'],
    ];

    domainUsers = [];

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public appService: AppService,
                public route: ActivatedRoute,
                public fb: FormBuilder) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
